<template>
  <hypto-popup :title="'Transaction Preferences'">
    <template v-slot:body>
      <div class="merge-fields">
        <b>Choose columns</b>
        <div v-for="(field, index) in fields" :key="index" class="preferences">
          <p>{{field.text}}</p>
          <md-switch v-model="field.selected" @change="checkLength" />
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <h6 class="error-message" v-if="errorMsg">{{errorMsg}}</h6>
      <button class="primary-btn" @click="selectFields">Confirm</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/accountStatement'

export default {
  name: 'StatementPreferences',
  components: { HyptoPopup },
  props: {
    txnFields: Array
  },
  data () {
    return {
      fields: [],
      errorMsg: null
    }
  },
  watch: {
    txnFields: {
      handler: 'populateData',
      immediate: true
    }
  },
  methods: {
    populateData () {
      this.fields = this.txnFields.slice().map(e => Object.assign({}, e))
    },
    selectFields () {
      if (!this.errorMsg) {
        let fields = this.fields.filter(e => e.selected).map(e => e.key)
        ApiServices.selectFields({fields}).then(response => {
          this.successToastMsg(response.message)
          this.$emit('refreshList')
        })
      }
    },
    checkLength () {
      let fieldsLen = this.fields.filter(e => e.selected).length
      if (fieldsLen < 4) {
        this.errorMsg = 'Please select atleast 4 columns'
      } else if (fieldsLen > 10) {
        this.errorMsg = 'Please select upto 10 columns'
      } else {
        this.errorMsg = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  b {
    display: block;
    text-align: left;
  }

  .preferences {
    @include custom-flex(space-between);
    margin: 2px 5px;
    padding: 5px 0;
    border-bottom: 1px solid $grey-outline;
  }
</style>
